<template>
    <UserDataContainer :description="description">
        <form class="user-data" @submit.prevent="onSubmit">
            <FormRow id="name" :error="getErrorLabel('name')">
                <FormInput
                    id="name"
                    v-model="data.name"
                    type="text"
                    placeholder="Name"
                    :error="hasError('name')"
                    @focus="clearError('name')"
                />
            </FormRow>

            <FormRow id="email" :error="getErrorLabel('email')">
                <FormInput
                    id="email"
                    v-model="data.email"
                    type="email"
                    placeholder="Email"
                    :error="hasError('email')"
                    @focus="clearError('email')"
                />
            </FormRow>

            <div class="checkbox-component">
                <input
                    id="consent"
                    v-model="data.consent"
                    type="checkbox"
                    @change="clearError('consent')"
                >
                <label for="consent" class="checkbox-label">
                    I agree to the <a href="https://fusebox.fm/terms-of-use/" target="_blank">Terms of Use</a> and <a href="https://fusebox.fm/privacy-policy/" target="_blank">Privacy Policy</a>
                </label>
            </div>

            <FormError
                v-if="hasError('consent')"
                :error="getErrorLabel('consent')"
            />

            <FormButton type="submit" class="is-purple">
                Continue
            </FormButton>
        </form>
    </UserDataContainer>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState, mapGetters, mapActions } from 'vuex';

/**
 * Internal dependencies.
 */
import FormButton from '@/components/Form/FormButton';
import FormError from '@/components/Form/FormError';
import FormInput from '@/components/Form/FormInput';
import FormRow from '@/components/Form/FormRow';
import UserDataContainer from './../UserDataContainer';

export default {
    components: {
        FormButton,
        FormError,
        FormInput,
        FormRow,
        UserDataContainer,
    },

    data: () => ({
        description: "You're just a few steps away from joining the growing community of podcasters using Fusebox.",
        data: {
            name: '',
            email: '',
            consent: false,
        },
    }),

    computed: {
        ...mapGetters('register', [
            'getError',
            'hasError',
        ]),

        ...mapState('register', {
            userData: state => state.data,
        }),
    },

    /**
     * Handles the component mount.
     */
    mounted() {
        this.data.name = this.userData.name;
        this.data.email = this.userData.email;
    },

    methods: {
        ...mapActions('register', [
            'updateData',
            'validateData',
            'clearError',
            'clearErrors',
        ]),

        /**
         * Handles form submit.
         */
        async onSubmit() {
            this.clearErrors();

            if (! (await this.validateData(this.data))) {
                return;
            }

            this.updateData(this.data);
            this.$emit('continue');
        },

        /**
         * Gets the label of the field error.
         *
         * @param   {string} field Field name
         * @returns {string}       Error.
         */
        getErrorLabel(field) {
            const error = this.getError(field);

            if ('required' === error) {
                return 'This field is required.';
            }

            if ('accept' === error && 'consent' === field) {
                return 'To continue you need to accept our Terms of Use and Privacy Policy.';
            }

            return error;
        },
    },
};
</script>
<style scoped lang="scss">
    @use './UserData.scss';
</style>
